/*
 * params: dateTimeString type: string
 * returns: boolean, true if invalid
 */
export const isInvalidDateTime = (dateTimeString) => {
  const validationRegexp = /(\d{2})-(\d{2})-(\d{4}) (\d{2}):(\d{2}):(\d{2})/;
  return !validationRegexp.test(dateTimeString);
};

const getDateTimeFromString = (dateTimeString, isEndDate) => {
  const [date, time = isEndDate ? '24:00:00' : '00:00:00'] = dateTimeString.split(' ');
  const [day, month, year] = date.split('-');
  const [hour, minute, second] = time.split(':');

  return new Date(year, month - 1, day, hour, minute, second);
};

export const isInDate = (startDateTime, endDateTime) => {
  const currentDate = Date.now();
  const startDate = getDateTimeFromString(startDateTime, false);
  const endDate = getDateTimeFromString(endDateTime, true);

  const isCurrentBetweenStartAndEnd = startDate < currentDate && currentDate < endDate;
  const isStartBeforeEnd = startDate < endDate;

  return isCurrentBetweenStartAndEnd && isStartBeforeEnd;
};

export default isInDate;
